export default __webpack_public_path__ + "static/media/Eric_F.089f5a65.jpg";